export type FilterData = {
  practitionerIds?: string[]
}

class FilterStorageService {
  private readonly storageKey = 'calendar-filter-data'

  get(): FilterData | null {
    try {
      const raw = sessionStorage.getItem(this.storageKey)
      return raw ? (JSON.parse(raw) as FilterData) : null
    } catch {
      return null
    }
  }

  set(data: FilterData): void {
    const existing = this.get() ?? {}
    sessionStorage.setItem(this.storageKey, JSON.stringify({ ...existing, ...data }))
  }

  clear(): void {
    sessionStorage.removeItem(this.storageKey)
  }
}

export const filterStorageService = new FilterStorageService()
